/* eslint-disable max-len */
export default {
  id: 'de',
  messages: {
    'dst.empty.title': 'Geben Sie oben einige Suchbegriffe ein, um loszulegen',
    'dst.empty.text': 'Suchen Sie im obigen Feld nach einem bestimmten Domainnamen oder geben Sie Suchbegriffe ein, um nach Ihrer perfekten Domain zu suchen.',
    'dst.search.basket': 'Warenkorb anzeigen',
    'dst.searching.title': 'Suche\u2026',
    'dst.searching.text': 'Einen Moment bitte',
    'dst.noResults.title': 'Es wurden leider keine passenden Domains gefunden',
    'dst.noResultsHasExact.title': 'Es wurden leider keine passenden Domains gefunden',
    'dst.noResults.text': 'Versuchen Sie, weniger Filter zu verwenden, oder benutzen Sie Schlagwörter. (Überprüfen Sie die Rechtschreibung)',
    'dst.error.title': 'Es ist ein Fehler aufgetreten.',
    'dst.error.text': 'Versuchen Sie es bitte noch einmal.',
    'dst.exactMatch.v2.notFound.text': 'Sorry, {domain} wurde bereits registriert.',
    'dst.exactMatch.v2.void.text': 'Sorry, {domain} ist ungültig.',
    'dst.exactMatch.v2.found.text': 'Ja! Ihre Domain ist verfügbar. Jetzt registrieren, bevor es zu spät ist!',
    'dst.exactMatch.v2.price': 'Nur {price}',
    'dst.exactMatch.v2.oldPrice': '{price}',
    'dst.exactMatch.v2.promo.price': 'Jetzt {price}',
    'dst.exactMatch.v2.buy': 'In den Warenkorb',
    'dst.exactMatch.v2.verifying': 'Überprüfen\u2026',
    'dst.exactMatch.v2.available': 'Hinzugefügt',
    'dst.exactMatch.v2.unavailable': 'Leider nicht verfügbar',
    'dst.exactMatch.v2.basket': 'Warenkorb ansehen',
    'dst.exactMatch.v2.backorder': 'Backorder anfordern',
    'dst.exactMatch.v2.transfer': 'Transfer meiner Domain',
    'dst.exactMatch.v2.promo': 'Sale!',
    'dst.exactMatch.v2.notFound.transferOrBackorder': 'Wenn Sie diese Domain bereits besitzen, können Sie sie zu uns transferieren, oder Sie können eine Backorder dieser Domain beantragen.',
    'dst.exactMatch.v2.notFound.transfer': 'Wenn Sie diese Domain bereits besitzen, können Sie sie zu uns transferieren.',
    'dst.exactMatch.v2.notFound.backorder': 'Sie können eine Backorder für diese Domain beantragen.',
    'dst.standardDomains.title': 'Folgende Domains haben wir für Sie gefunden',
    'dst.standardDomains.sale': 'im Angebot!',
    'dst.standardDomains.ad': 'Ad',
    'dst.standardDomains.domainTerm': 'Alle angegebenen Preise gelten für 1 Jahr, sofern nicht anders angegeben.',
    // 'dst.standardDomains.taxation': 'Alle Preise verstehen sich zuzüglich 20% MwSt.', // optional
    'dst.standardDomains.price': '{price} / Monat*',
    'dst.standardDomains.oldPrice': '{price} / Monat*',
    'dst.standardDomains.buy': 'In den Warenkorb legen',
    'dst.standardDomains.transfer': 'Transfer meiner Domain',
    'dst.standardDomains.backorder': 'Backorder anfordern',
    'dst.standardDomains.verifying': 'Bestätigen\u2026',
    'dst.standardDomains.available': 'Ihrem {basketLink} hinzugefügt',
    'dst.standardDomains.unavailable': 'Diese Domain ist nicht verfügbar.',
    'dst.standardDomains.basket': 'Warenkorb',
    'dst.filters.tlds.all': 'Alle anzeigen',
    'dst.filters.exactOnly': 'Nur exakte Treffer anzeigen',
    'dst.exactMatch.v3.notFound.none': ' ',
  },
};
/* eslint-enable max-len */
